import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rolestatistics',
  templateUrl: './rolestatistics.component.html',
  styleUrls: ['./rolestatistics.component.scss']
})
export class RolestatisticsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
